<template>

  <div>
    <Admin v-if="!this.$store.getters.Veznedar"></Admin>
    <Veznedar v-if="this.$store.getters.Veznedar"></Veznedar>
  </div>
</template>
<script>

  import Admin from "./Admin";
  import Veznedar from "./Veznedar";

  export default {
    components: {Veznedar, Admin},
    data() {
      return {}
    },
    methods: {},
    created() {

    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Panel/index.vue